import React, { useEffect } from 'react';

let _kfDone = false;
function injectKF() {
  if (_kfDone || document.getElementById('ait-kf')) return;
  _kfDone = true;
  const s = document.createElement('style');
  s.id = 'ait-kf';
  s.textContent = `@keyframes aitSlideUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}`;
  document.head.appendChild(s);
}

export function AdaptiveInsightToast({ insight, accentColor, onAccept, onDismiss }) {
  useEffect(() => { injectKF(); }, []);
  if (!insight) return null;

  const accent = accentColor || '#34d399';
  return (
    <div style={{
      position: 'fixed', bottom: 134, left: '50%', transform: 'translateX(-50%)',
      zIndex: 848, width: 'min(360px, calc(100vw - 48px))',
      background: 'rgba(6,12,38,0.97)', backdropFilter: 'blur(14px)',
      border: `1px solid ${accent}30`, borderRadius: 14,
      padding: '14px 18px', boxShadow: '0 8px 36px rgba(0,0,0,0.6)',
      animation: 'aitSlideUp .32s ease',
      fontFamily: '-apple-system,BlinkMacSystemFont,"Inter","Segoe UI",sans-serif',
    }}>
      <p style={{ margin: '0 0 12px', fontSize: 13, color: 'rgba(172,196,236,0.85)', lineHeight: 1.6 }}>
        {insight.message}
      </p>
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={onAccept} style={{
          flex: 1, padding: '8px 0', fontSize: 12.5,
          background: `${accent}18`, border: `1px solid ${accent}40`,
          color: accent, borderRadius: 8, cursor: 'pointer', fontFamily: 'inherit',
        }}>Sim</button>
        <button onClick={onDismiss} style={{
          flex: 1, padding: '8px 0', fontSize: 12.5,
          background: 'none', border: '1px solid rgba(255,255,255,0.08)',
          color: 'rgba(100,116,139,0.65)', borderRadius: 8,
          cursor: 'pointer', fontFamily: 'inherit',
        }}>Agora não</button>
      </div>
    </div>
  );
}
